module.exports = __webpack_public_path__ + "media/images/icons/document-8a43a69836288f881cd96ce991f89f79.svg";